import * as React from "react";

const SvgRaindrops = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath id="c" clipPathUnits="userSpaceOnUse">
        <path d="m291.923 675.503-2.886-5a2 2 0 0 1 .732-2.732 2.002 2.002 0 0 1 2.733.732l2.886 5a2 2 0 0 1-.733 2.732 1.999 1.999 0 0 1-2.732-.732" />
      </clipPath>
      <clipPath id="e" clipPathUnits="userSpaceOnUse">
        <path d="m286.924 682.682-2.888-4.999a2 2 0 0 1 .733-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2.001 2.001 0 0 1-.733 2.732 1.997 1.997 0 0 1-2.732-.733" />
      </clipPath>
      <clipPath id="a" clipPathUnits="userSpaceOnUse">
        <path d="m286.924 682.682-2.888-4.999a2 2 0 0 1 .733-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2.001 2.001 0 0 1-.733 2.732 1.997 1.997 0 0 1-2.732-.733" />
      </clipPath>
      <clipPath id="b" clipPathUnits="userSpaceOnUse">
        <path d="m303.035 682.682-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2.001 2.001 0 0 1-.732 2.732 2 2 0 0 1-2.733-.733" />
      </clipPath>
      <clipPath id="f" clipPathUnits="userSpaceOnUse">
        <path d="m303.035 682.682-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2.001 2.001 0 0 1-.732 2.732 2 2 0 0 1-2.733-.733" />
      </clipPath>
      <clipPath id="h" clipPathUnits="userSpaceOnUse">
        <path d="m308.536 675.503-2.887-5a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.886 5a2 2 0 0 1-.731 2.732 1.997 1.997 0 0 1-2.733-.732" />
      </clipPath>
      <clipPath id="g" clipPathUnits="userSpaceOnUse">
        <path d="m291.923 675.503-2.886-5a2 2 0 0 1 .732-2.732 2.002 2.002 0 0 1 2.733.732l2.886 5a2 2 0 0 1-.733 2.732 1.999 1.999 0 0 1-2.732-.732" />
      </clipPath>
      <clipPath id="d" clipPathUnits="userSpaceOnUse">
        <path d="m308.536 675.503-2.887-5a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.886 5a2 2 0 0 1-.731 2.732 1.997 1.997 0 0 1-2.733-.732" />
      </clipPath>
    </defs>
    <g fill="#00b6f1">
      <path
        d="m286.924 682.682-2.888-4.999a2 2 0 0 1 .733-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2.001 2.001 0 0 1-.733 2.732 1.997 1.997 0 0 1-2.732-.733"
        clipPath="url(#a)"
        transform="matrix(1.43463 0 0 -1.43463 -382.545 1027.223)"
      />
      <path
        d="m303.035 682.682-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2.001 2.001 0 0 1-.732 2.732 2 2 0 0 1-2.733-.733"
        clipPath="url(#b)"
        transform="matrix(1.43463 0 0 -1.43463 -382.545 1027.223)"
      />
      <path
        d="m291.923 675.503-2.886-5a2 2 0 0 1 .732-2.732 2.002 2.002 0 0 1 2.733.732l2.886 5a2 2 0 0 1-.733 2.732 1.999 1.999 0 0 1-2.732-.732"
        clipPath="url(#c)"
        transform="matrix(1.43463 0 0 -1.43463 -382.545 1027.223)"
      />
      <path
        d="m308.536 675.503-2.887-5a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.886 5a2 2 0 0 1-.731 2.732 1.997 1.997 0 0 1-2.733-.732"
        clipPath="url(#d)"
        transform="matrix(1.43463 0 0 -1.43463 -382.545 1027.223)"
      />
      <path
        d="m286.924 682.682-2.888-4.999a2 2 0 0 1 .733-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2.001 2.001 0 0 1-.733 2.732 1.997 1.997 0 0 1-2.732-.733"
        clipPath="url(#e)"
        transform="matrix(1.43463 0 0 -1.43463 -376.545 1007.223)"
      />
      <path
        d="m303.035 682.682-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2.001 2.001 0 0 1-.732 2.732 2 2 0 0 1-2.733-.733"
        clipPath="url(#f)"
        transform="matrix(1.43463 0 0 -1.43463 -376.545 1007.223)"
      />
      <path
        d="m291.923 675.503-2.886-5a2 2 0 0 1 .732-2.732 2.002 2.002 0 0 1 2.733.732l2.886 5a2 2 0 0 1-.733 2.732 1.999 1.999 0 0 1-2.732-.732"
        clipPath="url(#g)"
        transform="matrix(1.43463 0 0 -1.43463 -376.545 1007.223)"
      />
      <path
        d="m308.536 675.503-2.887-5a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.886 5a2 2 0 0 1-.731 2.732 1.997 1.997 0 0 1-2.733-.732"
        clipPath="url(#h)"
        transform="matrix(1.43463 0 0 -1.43463 -376.545 1007.223)"
      />
    </g>
    <path
      fill="none"
      d="M0 0h96v96H0z"
      opacity=".997"
      paintOrder="stroke fill markers"
    />
  </svg>
);

export default SvgRaindrops;
